import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRef } from 'vue'

import RouteManager from '../RouteManager.vue'
import DocumentManager from '../../documents/manager/DocumentManager.vue'
import TransportationDateTimeRangePicker from '../TransportationDateTimeRangePicker.vue'
import TransportationLocationSelector from '../TransportationLocationSelector.vue'
import TransportationEmojiLabelField from '../TransportationEmojiLabelField.vue'
import FormGroup from '@/components/core/form/FormGroup.vue'
import LTextarea from '@/components/core/form/Textarea.vue'
import { useSelectedTrip } from '@/composables/trip'
import { useTransportationDocuments } from '@/composables/transportation'
import { useTransportationStore } from '@/stores/transportation'
import { WalkingTransportationUIInput } from '@/types/transportation'


export default /*#__PURE__*/_defineComponent({
  __name: 'WalkingForm',
  props: {
    transportation: null,
    waypointId: null
  },
  setup(__props: any) {

const props = __props as {
  transportation: WalkingTransportationUIInput
  waypointId: string
};



const trip = useSelectedTrip()
const transportationStore = useTransportationStore()
const transportation = toRef(props, 'transportation')

const idPrefix = computed(() => {
  return `transportation-${transportation.value._id ?? 'walking-new'}`
})

// Document Management ---------------------------------------------------------

const managedDocuments = useTransportationDocuments(transportation)

// Show/Hide More Content ------------------------------------------------------

const hasContentInMoreSection =
  managedDocuments.value.length > 0 || !!transportation.value.comment

const showContent = ref(hasContentInMoreSection)

function toggleMoreContent() {
  showContent.value = !showContent.value
}

return { __sfc: true,props, trip, transportationStore, transportation, idPrefix, managedDocuments, hasContentInMoreSection, showContent, toggleMoreContent, RouteManager, DocumentManager, TransportationDateTimeRangePicker, TransportationLocationSelector, TransportationEmojiLabelField, FormGroup, LTextarea }
}

})